import { getTableViewByType } from './table-view';

export function FactInfoComponent($compile) {
  return {
    restrict  : 'E',
    scope     : {
      filter   : '<',
      fact     : '<',
      showImage: '<',
    },
    controller: function ($scope, $element, $sce) {
      $scope.trustAsHtml = $sce.trustAsHtml;
    },
    link      : function (scope, element, attrs) {
      scope.$watch('fact', update);
      scope.$watch('filter', update);

      function update() {
        if (!scope.filter || !scope.fact) return;
        let newVal = scope.fact;
        let fact = newVal ? newVal : {};
        scope.textData = fact ? fact['text_data'] : '';
        scope.event_id = fact ? fact['id'] : 0;
        let viewMode = getTableViewByType(fact['agent_eventtype.id']);
        let widget = viewMode.important.map(colView => {
          let data = colView.parse(fact, 'extended');
          let label = ( data && colView.label ) ?
            '<span class="label">' + colView.label + ':</span> ' : '';
          return label + data + ( (label + data) ? '<br/>' : '');
        }).join('', '');
        element.html(widget);
        $compile(element.contents())(scope);
      }
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-info.component.js